import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-boardofresearch',
    templateUrl: './boardofresearch.component.html',
    styleUrls: ['./boardofresearch.component.scss']
})
export class BoardofresearchComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI’s Board of Research: Advancing Innovation and Discovery');
        this.meta.updateTag({
            name: 'description',
            content: `Discover the Board of Research at ARNI, driving innovation, fostering groundbreaking studies, and shaping a future of knowledge and progress.`
        });
    }


}
